import { atom } from "jotai";
import { atomWithImmer } from "jotai-immer";

import type { AddressBookState } from "../types";

export const initialState: AddressBookState = {
  addressBookName: "contacts",
  mode: "view",
  categories: [],
  contacts: [],
  isVisible: false,
  selectedCategory: null,
  selectedContact: null,
  onChooserCallback: undefined,
};

export const addressBookAtom = atomWithImmer<AddressBookState>(initialState);

export const addressBookNameAtom = atom(
  (get) => get(addressBookAtom).addressBookName,
);
